export default __webpack_public_path__ + "static/media/Pross-Mac.e3b34162.webp";